import type { Location as BaseLocation } from 'react-router-dom';

import { dontFireBiEventNavigateState } from '../react-router/appRoutes';

export type HelpCenterProps = {
  routerInitialEntries: string[];
};

export type NavigationState = typeof dontFireBiEventNavigateState;

export interface Location extends BaseLocation {
  state: NavigationState | undefined;
}

export enum HelpCenterError {
  MORE_INFORMATION_NEEDED = 'MORE_INFORMATION_NEEDED',
  NO_ARTICLES = 'NO_ARTICLES',
}
